var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7202 13.6739C24.4825 14.1933 22.8415 15.6031 22.021 17.5323C21.9464 17.7549 21.8719 17.9033 21.7973 18.1259C21.7227 18.2743 21.7227 18.4969 21.6481 18.6453C21.5735 18.8679 21.5735 19.0905 21.4989 19.2389C21.4243 19.6099 21.4243 19.9809 21.4243 20.4261C21.4243 22.3553 22.021 23.9877 23.1399 25.1749L23.2145 25.2491C24.4825 26.6589 26.4219 27.4751 28.585 27.4751C30.1514 27.4751 31.7178 27.1041 32.9858 26.3621C33.4334 26.1395 33.7317 25.6943 33.7317 25.1749C33.7317 24.4329 33.0604 23.7651 32.3145 23.7651C32.0907 23.7651 31.867 23.8393 31.6432 23.9135C30.8227 24.3587 29.7784 24.6555 28.9579 24.6555C26.6456 24.6555 25.303 23.2457 25.0792 21.5391H32.9112C34.2539 21.5391 34.9998 21.0197 34.9998 19.9067C34.9998 16.4193 32.3145 13.4513 28.2866 13.4513C27.7645 13.5255 27.2424 13.5255 26.7202 13.6739ZM25.1544 18.8681C25.1544 18.6455 25.229 18.4971 25.3036 18.3487C25.7511 17.3099 26.6462 16.3453 28.3618 16.3453C30.6741 16.3453 31.5692 18.0519 31.6438 19.3133H25.0798C25.0798 19.0907 25.0798 18.9423 25.1544 18.8681Z",
    fill: "url(#paint0_linear_47_48753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.04 15.0098L11.5039 22.7266L9.26623 14.8614C9.04246 14.1194 8.44574 13.6 7.62525 13.6C6.65557 13.6 5.90967 14.342 5.90967 15.3066C5.90967 15.455 5.90967 15.6776 5.98426 15.826L8.96787 25.5462C9.26623 26.585 10.2359 27.2528 11.3548 27.2528C12.4736 27.2528 13.3687 26.5108 13.6671 25.5462L16.054 18.052L18.3663 25.5462C18.6646 26.585 19.6343 27.2528 20.7532 27.2528C21.872 27.2528 22.7671 26.5108 23.0655 25.5462L23.14 25.1752V25.101L25.0794 18.7198L25.2286 18.2004L26.6458 13.6C24.4827 14.1194 22.8417 15.5292 22.0212 17.4584C21.9466 17.681 21.872 17.8294 21.7974 18.052L21.6482 18.5714L21.4991 19.165L20.5294 22.6517L17.9933 14.9356C17.7695 14.1194 16.949 13.5258 16.054 13.5258C15.0843 13.6 14.2638 14.1936 14.04 15.0098Z",
    fill: "url(#paint1_linear_47_48753)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_48753",
    x1: 22.8184,
    y1: 23.3969,
    x2: 31.0478,
    y2: 25.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0515278,
    stopColor: "#2F3A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3573,
    stopColor: "#36A9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6827,
    stopColor: "#66C5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C5DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_48753",
    x1: 5.92926,
    y1: 27.2569,
    x2: 26.6467,
    y2: 27.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36A9E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3085,
    stopColor: "#3EADE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#52B8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66C5DB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareLight);
export default __webpack_public_path__ + "static/media/square-light.ca1aa9db8d37f42992705bed6a008a3e.svg";
export { ForwardRef as ReactComponent };